export class Plano {
    static svgMain = null;
    static gMainD3 = null;

    static setSvgMain(svg) {
        Plano.svgMain = svg;
    }

    static setGMainD3(gMainD3) {
        Plano.gMainD3 = gMainD3;
    }

    static getTransformPan() {
        return Plano.gMainD3.data()[0].transform;
    }

    static getMousePos(evt) {
        let svg = Plano.svgMain;
        let CTM = svg.getScreenCTM();
        // let x = Math.floor((evt.clientX - CTM.e) / CTM.a)
        // let y = Math.floor((evt.clientY - CTM.f) / CTM.d)
        let pnt = svg.createSVGPoint();
        pnt.x = evt.clientX;
        pnt.y = evt.clientY;
        let transform = Plano.getTransformPan();
        let iPNT = pnt.matrixTransform(CTM.inverse());
        let x = iPNT.x;
        let y = iPNT.y;
        if (transform != null) {
            x = (x - transform.x) / transform.k;
            y = (y - transform.y) / transform.k;
        }
        x = Math.floor(x);
        y = Math.floor(y);
        return { x, y };
    }

    static createObjectUrl(svg) {
        let DOMURL = self.URL || self.webkitURL || self;
        let data = new XMLSerializer().serializeToString(svg);
        let blob = new Blob([data], { type: "image/svg+xml;charset=utf-8" });
        let url = DOMURL.createObjectURL(blob);
        return url;
    }

    static drawImage(svg) {
        let url = Plano.createObjectUrl(svg);
        let image = new Image();
        image.src = url;
        // image.setAttribute('href', url)
        return new Promise(resolve => {
            image.onload = () => {
                resolve(image);
            };
        });
    }
}



// WEBPACK FOOTER //
// ./src/components/plano/components/Plano.js